import { createSelector } from "reselect"

// selectors
import {
    dataSourceHasData,
    selectWidgetDataSources,
} from "app/static/frontend/widgets/selectors/selectors"

const selectMeta = (_, props) => props.widget && props.widget.meta

export const selectVisSubtype = createSelector(
    selectMeta,
    meta => meta && meta.vis_subtype
)

export const selectVisWidgetCanLoad = createSelector(
    selectWidgetDataSources,
    dataSources => Boolean(
        dataSources &&
        dataSources.length &&
        dataSources.some(dataSource => dataSourceHasData(dataSource))
    )
)

export const selectLabels = createSelector(
    selectMeta,
    meta => (meta && meta.labels) || []
)

export const selectColors = createSelector(
    selectMeta,
    meta => (meta && meta.colors)
)

const selectVisOptions = createSelector(
    selectMeta,
    meta => (meta && meta.vis_options) || {}
)

const selectGroupBy = createSelector(
    selectWidgetDataSources,
    dataSources => (
        dataSources
        && dataSources.length
        && dataSources[0].group_by
    ) || {}
)

// for line
export const selectCumulative = createSelector(
    selectVisOptions,
    options => options && options.cumulative
)

export const selectInterval = createSelector(
    selectGroupBy,
    groupBy => groupBy.interval
)

// bar, map
export const selectFrequencyTupleField = createSelector(
    selectGroupBy,
    groupBy => groupBy.frequency_tuple_field
)
